<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.userAccount" style="width: 150px;" size="mini" placeholder="用户账号"
            clearable></el-input>
          <el-input v-model="formDatas.tradeNo" style="width: 200px; margin-left: 10px;" size="mini" placeholder="交易订单号"
            clearable></el-input>
          <el-input v-model="formDatas.orderNum" style="width: 200px; margin-left: 10px;" size="mini"
            placeholder="移动订单号" clearable></el-input>
          <el-input v-model="formDatas.mrchOrderNo" style="width: 200px; margin-left: 10px;" size="mini"
            placeholder="商户订单号" clearable></el-input>
          <el-select size="mini" v-model="formDatas.tradeStatus" clearable placeholder="交易状态"
            style="width: 120px; margin-left: 10px">
            <el-option label="待支付" :value="0" key="0"></el-option>
            <el-option label="成功" :value="1" key="1"></el-option>
            <el-option label="失败" :value="2" key="2"></el-option>
            <el-option label="已过期" :value="3" key="3"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.notifyStatus" clearable placeholder="通知状态"
            style="width: 120px; margin-left: 10px">
            <el-option label="待通知" :value="1" key="1"></el-option>
            <el-option label="已通知" :value="2" key="2"></el-option>
            <el-option label="通知失败" :value="3" key="3"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.ypoStatusRefund" clearable placeholder="是否退款"
            style="width: 100px; margin-left: 10px">
            <el-option label="否" :value="1" key="1"></el-option>
            <el-option label="是" :value="2" key="2"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.ypoHandlerStatus" clearable placeholder="处理状态"
            style="width: 120px; margin-left: 10px">
            <el-option label="不需要" :value="0" key="0"></el-option>
            <el-option label="否" :value="1" key="1"></el-option>
            <el-option label="是" :value="2" key="2"></el-option>
            <el-option label="失败" :value="3" key="3"></el-option>
          </el-select>
          <el-date-picker size="mini" v-model="tradeTimeRange" type="daterange" start-placeholder="交易开始日期"
            end-placeholder="交易结束日期" value-format="yyyy-MM-dd" style="width: 240px; margin-left: 10px"></el-date-picker>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <el-button type="warning" size="mini" style="margin-left: 10px" @click="handleExport">导出</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="900px">
      <div v-if="detailData" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="商户订单号">{{ detailData.mrchOrderNo }}</el-descriptions-item>
          <el-descriptions-item label="交易订单号">{{ detailData.tradeNo }}</el-descriptions-item>
          <el-descriptions-item label="商户号">{{ detailData.merchantNo }}</el-descriptions-item>
          <el-descriptions-item label="用户账号">{{ detailData.userAccount }}</el-descriptions-item>
          <el-descriptions-item label="支付金额">{{ detailData.payAmount ? (detailData.payAmount / 100).toFixed(2) + '元' :
            '-' }}</el-descriptions-item>
          <el-descriptions-item label="成本价金额">{{ detailData.payCostAmount ? (detailData.payCostAmount / 100).toFixed(2)
            + '元' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="交易状态">
            <el-tag :type="getTradeStatusType(detailData.tradeStatus)" size="small">{{
              getTradeStatusText(detailData.tradeStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="通知状态">
            <el-tag :type="getNotifyStatusType(detailData.notifyStatus)" size="small">{{
              getNotifyStatusText(detailData.notifyStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="是否退款">
            <el-tag :type="detailData.ypoStatusRefund === 2 ? 'danger' : 'success'" size="small">{{
              detailData.ypoStatusRefund === 2 ? '是' : '否' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="处理状态">
            <el-tag :type="getHandlerStatusType(detailData.ypoHandlerStatus)" size="small">{{
              getHandlerStatusText(detailData.ypoHandlerStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="处理状态描述" :span="2">{{ detailData.ypoHandlerStatusDes || '-'
            }}</el-descriptions-item>
          <el-descriptions-item label="交易日期">{{ detailData.transDate }}</el-descriptions-item>
          <el-descriptions-item label="过期时间">{{ detailData.expireTime }}</el-descriptions-item>
          <el-descriptions-item label="交易时间">{{ detailData.tradeTime }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ detailData.createtime }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{ detailData.updatetime }}</el-descriptions-item>
          <el-descriptions-item label="回调地址" :span="2">{{ detailData.backUrl }}</el-descriptions-item>
          <el-descriptions-item label="通知地址" :span="2">{{ detailData.notifyUrl }}</el-descriptions-item>
        </el-descriptions>

        <!-- 运营描述 -->
        <div style="margin-top: 20px">
          <h4>运营描述</h4>
          <el-input type="textarea" v-model="operationDes" :rows="3" placeholder="请输入运营描述"></el-input>
          <el-button type="primary" size="small" style="margin-top: 10px" @click="saveOperationDes">保存运营描述</el-button>
        </div>

        <div v-if="detailData.productInfoList && detailData.productInfoList.length > 0" style="margin-top: 20px">
          <h4>商品信息</h4>
          <el-table :data="detailData.productInfoList" border size="small">
            <el-table-column prop="itemName" label="商品名称" />
            <el-table-column prop="itemCode" label="商品编码" />
            <el-table-column label="商品销售价">
              <template slot-scope="scope">
                {{ scope.row.salePrice ? (scope.row.salePrice).toFixed(2) + '元' : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="saleNum" label="销售数量" />
            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <el-image v-if="scope.row.photo" :src="scope.row.photo" style="width: 50px; height: 50px" fit="cover"
                  :preview-src-list="[scope.row.photo]" />
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getYbtPayOrderCopyList, getYbtPayOrderCopyDetails, updatYbtPayOrderCopyHandlerOperation } from "../../api/api";
import axios from 'axios';
import qs from "qs";
import config from "../../api/env.js";

export default {
  name: "YbtPayOrderCopy",
  data() {
    return {
      tableLoading: false,
      loadings: null,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      dialogVisible: false,
      detailData: null,
      operationDes: '',
      tradeTimeRange: [],
      formDatas: {
        userAccount: '',
        tradeNo: '',
        orderNum: '',
        mrchOrderNo: '',
        tradeStatus: null,
        notifyStatus: null,
        ypoStatusRefund: null,
        ypoHandlerStatus: null,
        tradeTimeStart: '',
        tradeTimeEnd: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "mrchOrderNo",
          key: "mrchOrderNo",
          title: "商户订单号",
          width: 250,
          align: "center",
        },
        {
          field: "ypopId",
          key: "ypopId",
          title: "商品订单ID",
          width: 100,
          align: "center",
        },
        {
          field: "ypoId",
          key: "ypoId",
          title: "订单ID",
          width: 90,
          align: "center",
        },
        {
          field: "itemCode",
          key: "itemCode",
          title: "商品编码",
          width: 150,
          align: "center",
        },
        {
          field: "itemName",
          key: "itemName",
          title: "商品名称",
          width: 280,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.itemName) return '-';
            return h('el-tooltip', {
              props: { content: row.itemName, placement: 'top', 'open-delay': 500 }
            }, [
              h('span', { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '260px' } }, row.itemName)
            ]);
          },
        },
        {
          field: "salePrice",
          key: "salePrice",
          title: "商品销售价",
          width: 100,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.salePrice || row.salePrice === 0 ? Number(row.salePrice).toFixed(2) + '元' : '-';
          },
        },
        {
          field: "saleNum",
          key: "saleNum",
          title: "销售数量",
          width: 80,
          align: "center",
        },
        {
          field: "photo",
          key: "photo",
          title: "商品图片",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.photo) return '-';
            return h('el-image', {
              props: { src: row.photo, fit: 'cover', 'preview-src-list': [row.photo] },
              style: { width: '40px', height: '40px' }
            });
          },
        },
        {
          field: "arfdId",
          key: "arfdId",
          title: "权益账户ID",
          width: 100,
          align: "center",
        },
        {
          field: "orderNum",
          key: "orderNum",
          title: "移动订单号",
          width: 250,
          align: "center",
        },
        {
          field: "merchantNo",
          key: "merchantNo",
          title: "商户号",
          width: 120,
          align: "center",
        },
        {
          field: "userAccount",
          key: "userAccount",
          title: "用户账号",
          width: 150,
          align: "center",
        },
        {
          field: "tradeNo",
          key: "tradeNo",
          title: "交易订单号",
          width: 250,
          align: "center",
        },
        {
          field: "payAmount",
          key: "payAmount",
          title: "支付金额",
          width: 100,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.payAmount || row.payAmount === 0 ? (row.payAmount / 100).toFixed(2) + '元' : '-';
          },
        },
        {
          field: "payCostAmount",
          key: "payCostAmount",
          title: "成本价金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.payCostAmount || row.payCostAmount === 0 ? (row.payCostAmount / 100).toFixed(2) + '元' : '-';
          },
        },
        {
          field: "transDate",
          key: "transDate",
          title: "交易日期",
          width: 170,
          align: "center",
        },
        {
          field: "expireTime",
          key: "expireTime",
          title: "过期时间",
          width: 170,
          align: "center",
        },
        {
          field: "tradeStatus",
          key: "tradeStatus",
          title: "交易状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('el-tag', { props: { type: this.getTradeStatusType(row.tradeStatus), size: 'mini' } }, this.getTradeStatusText(row.tradeStatus));
          },
        },
        {
          field: "notifyStatus",
          key: "notifyStatus",
          title: "通知状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('el-tag', { props: { type: this.getNotifyStatusType(row.notifyStatus), size: 'mini' } }, this.getNotifyStatusText(row.notifyStatus));
          },
        },
        {
          field: "ypoSyncEquityfee",
          key: "ypoSyncEquityfee",
          title: "是否同步",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const isSync = row.ypoSyncEquityfee === 2;
            return h('el-tag', { props: { type: isSync ? 'success' : 'info', size: 'mini' } }, isSync ? '是' : '否');
          },
        },
        {
          field: "ypoStatusRefund",
          key: "ypoStatusRefund",
          title: "是否退款",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const isRefund = row.ypoStatusRefund === 2;
            return h('el-tag', { props: { type: isRefund ? 'danger' : 'success', size: 'mini' } }, isRefund ? '是' : '否');
          },
        },
        {
          field: "ypoHandlerStatus",
          key: "ypoHandlerStatus",
          title: "处理状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('el-tag', { props: { type: this.getHandlerStatusType(row.ypoHandlerStatus), size: 'mini' } }, this.getHandlerStatusText(row.ypoHandlerStatus));
          },
        },
        {
          field: "ypoHandlerStatusDes",
          key: "ypoHandlerStatusDes",
          title: "处理状态描述",
          width: 180,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.ypoHandlerStatusDes) return '-';
            return h('el-tooltip', {
              props: { content: row.ypoHandlerStatusDes, placement: 'top', 'open-delay': 500 }
            }, [
              h('span', { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '160px' } }, row.ypoHandlerStatusDes)
            ]);
          },
        },
        {
          field: "tradeTime",
          key: "tradeTime",
          title: "交易时间",
          width: 170,
          align: "center",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          width: 170,
          align: "center",
        },
        {
          field: "updatetime",
          key: "updatetime",
          title: "更新时间",
          width: 170,
          align: "center",
        },
        {
          field: "action",
          key: "action",
          title: "操作",
          width: 80,
          align: "center",
          fixed: 'right',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('el-button', {
              props: { type: 'text', size: 'mini' },
              style: { color: '#409EFF', padding: '0 5px' },
              on: { click: () => this.handleDetail(row) }
            }, '详情');
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
    tradeTimeRange(val) {
      if (val && val.length === 2) {
        this.formDatas.tradeTimeStart = val[0];
        this.formDatas.tradeTimeEnd = val[1];
      } else {
        this.formDatas.tradeTimeStart = '';
        this.formDatas.tradeTimeEnd = '';
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.formDatas,
        tradeStatus: this.formDatas.tradeStatus !== null ? this.formDatas.tradeStatus : undefined,
        notifyStatus: this.formDatas.notifyStatus !== null ? this.formDatas.notifyStatus : undefined,
        ypoStatusRefund: this.formDatas.ypoStatusRefund !== null ? this.formDatas.ypoStatusRefund : undefined,
        ypoHandlerStatus: this.formDatas.ypoHandlerStatus !== null ? this.formDatas.ypoHandlerStatus : undefined,
      };
      getYbtPayOrderCopyList(params).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    handleDetail(row) {
      getYbtPayOrderCopyDetails({ ypoId: row.ypoId }).then((res) => {
        this.detailData = res.data;
        this.operationDes = res.data.ypoHandlerOperation || '';
        this.dialogVisible = true;
      }).catch(() => {
        this.$message.error('获取详情失败');
      });
    },
    saveOperationDes() {
      if (!this.detailData) return;
      updatYbtPayOrderCopyHandlerOperation({
        ypoId: this.detailData.ypoId,
        ypoHandlerOperation: this.operationDes
      }).then(() => {
        this.$message.success('保存成功');
        this.detailData.ypoHandlerOperation = this.operationDes;
        this.getList();
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },
    handleExport() {
      const params = {
        userAccount: this.formDatas.userAccount,
        tradeNo: this.formDatas.tradeNo,
        mrchOrderNo: this.formDatas.mrchOrderNo,
        tradeStatus: this.formDatas.tradeStatus,
        notifyStatus: this.formDatas.notifyStatus,
        ypoStatusRefund: this.formDatas.ypoStatusRefund,
        ypoHandlerStatus: this.formDatas.ypoHandlerStatus,
        tradeTimeStart: this.formDatas.tradeTimeStart,
        tradeTimeEnd: this.formDatas.tradeTimeEnd
      };
      const s = qs.stringify(params);
      this.openLoading();
      axios({
        method: 'post',
        url: config.baseURL2 + '/ybt-pay-order-copy/exportYbtPayOrderCopy',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then((res) => {
        if (res.data) {
          this.loadings.close();
          const a = document.createElement('a');
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          const objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '易宝通订单记录.xlsx');
          a.click();
          this.$message.success('导出成功');
        }
      }).catch(() => {
        this.loadings.close();
        this.$message.error('导出失败');
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: "导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    getTradeStatusText(status) {
      const map = { 0: '待支付', 1: '成功', 2: '失败', 3: '已过期' };
      return map[status] || '-';
    },
    getTradeStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' };
      return map[status] || 'info';
    },
    getNotifyStatusText(status) {
      const map = { 1: '待通知', 2: '已通知', 3: '通知失败' };
      return map[status] || '-';
    },
    getNotifyStatusType(status) {
      const map = { 1: 'warning', 2: 'success', 3: 'danger' };
      return map[status] || 'info';
    },
    getHandlerStatusText(status) {
      const map = { 0: '不需要', 1: '否', 2: '是', 3: '失败' };
      return map[status] || '-';
    },
    getHandlerStatusType(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' };
      return map[status] || 'info';
    },
  },
};
</script>

<style scoped>
.detail-content {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
